import { connect } from "react-redux";
import Runbooks from "./Runbooks";
import {
  getRunbooksRequest,
  createRunbookRequest,
  updateRunbookRequest,
  deleteRunbookRequest,
  getRunbookDetailRequest,
} from "../../store/actions/runbooks.actions";
import {
  allRunbooks,
  runbooksPagination,
  runbooksPageLoading,
  runbookLoading,
  runbookDetail,
  runbookDetailLoading,
} from "../../store/selectors/runbooks.selector";

const mapStateToProps = (state) => ({
  runbooks: allRunbooks(state),
  pagination: runbooksPagination(state),
  pageLoading: runbooksPageLoading(state),
  loading: runbookLoading(state),
  runbookItem: runbookDetail(state),
  runbookItemLoading: runbookDetailLoading(state),
});

const mapDispatchToProps = {
  getRunbooksRequest,
  getRunbookDetailRequest,
  createRunbookRequest,
  updateRunbookRequest,
  deleteRunbookRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(Runbooks);
